import { ClientStatus } from '@/modules/clients/types';
import { Currency } from '@/modules/common/types/currency';
import { CustomAttribute } from '@/modules/common/types/custom-attribute';
import { IntegrationServices } from '@/modules/common/types/integrations';
import { OpsiumUserShort } from '@/modules/common/types/opsium-user';
import { RateSource } from '@/modules/common/types/rate-source';
import { ProjectIntegration } from '@/modules/projects/types/project-integration';
import { ProjectTeamMember } from '@/modules/projects/types/project-team-member';

export interface Project {
  id: number;
  name: string | undefined;
  client?: ShortClient;
  info: ProjectInfo;
  billing: ProjectBilling;
  integrations: ProjectIntegrations;
  nextArchiveDate?: string | null;
  nextUnarchiveDate?: string | null;
}

export interface ProjectListItem {
  id: number;
  name: string;
  logoUrl: string;
  colorHex: string;
  status: ProjectStatus;
  tentativeProbability?: number | null;
  billingModel?: ProjectBillingModel | null;
  managers?: Manager[];
  defaultCurrency: Currency;
  projectStartDate?: string | null;
  projectEndDate?: string | null;
  nextArchiveDate?: string | null;
  nextUnarchiveDate?: string | null;
  industries?: Array<string> | null;
  connectedIntegrations: Array<IntegrationServices>;
  client?: ShortClient | null;
}

export interface ShortClient {
  id: number;
  name: string;
  logoUrl?: string | null;
  status: ClientStatus;
  isDeleted: boolean;
}

export interface ProjectInfo {
  colorHex: string | null;
  name: string;
  logoUrl: string;
  status: ProjectStatus;
  tentativeProbability: number | null;
  archivedDate: string | null;
  managers: Manager[];
  projectStartDate: string | null;
  projectEndDate: string | null;
  industries: string[] | null;
  description: string | null;
  customAttributesValues: CustomAttribute[];
  client?: ShortClient;
}

export interface ProjectBilling {
  billingModel: ProjectBillingModel | null;
  defaultCurrency: Currency;
  rateSource: RateSource;
  flatRate: number | null;
  budget: number | null;
  userRates: ProjectTeamMember[];
  paymentDetailsId: number | null;
}

export interface ProjectIntegrations {
  integrations: ProjectIntegration[];
}

export type ProjectIndustry = string;

export enum ProjectStatus {
  Tentative = 'TENTATIVE',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export enum ProjectBillingModel {
  TM = 'TIME_AND_MATERIALS',
  FixedPrice = 'FIXED_PRICE',
  NonBillable = 'NON_BILLABLE',
}

export type Manager = OpsiumUserShort;
